import { Typography } from '@mui/material';
import { ProductGroups } from 'enums';
import getLocalizedText from 'features/co-pilot/translationFileProduct';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  productGroup: ProductGroups;
}

const SourcingContacts: React.FC<Props> = ({ productGroup }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <div className={classes.titleContainer}>
        <Typography className={classes.title}>{t('sourcingContacts')}</Typography>
      </div>
      <div className={classes.scrollContent}>
        <section className={classes.section}>
          <Typography className={classes.sectionTitle}>{t('howAreContactsGenerated')}</Typography>
          <Typography className={classes.sectionText}>{t('contactsGeneratedDescription')}</Typography>
        </section>
        <section className={classes.section}>
          <Typography className={classes.sectionTitle}>{t('whatIsSourcingContacts')}</Typography>
          <Typography className={classes.sectionText}>{getLocalizedText('sourcingContactsDescription', productGroup, t)}</Typography>
          <ul className={classes.sectionList}>
            <Typography component="li" className={classes.sectionText}>
              {getLocalizedText('uploadExistingFile', productGroup, t)}
            </Typography>
            <Typography component="li" className={classes.sectionText}>
              {getLocalizedText('aiSearchForLeads', productGroup, t)}
            </Typography>
            <Typography component="li" className={classes.sectionText}>
              {t('manualLinkedInSearch')}
            </Typography>
          </ul>
        </section>
        <section className={classes.section}>
          <Typography className={classes.sectionTitle}>{t('supportedLinkedInSearches')}</Typography>
          <Typography className={classes.sectionText}>{t('aiSupportsTwoSearches')}</Typography>
          <ul className={classes.sectionList}>
            <Typography component="li" className={classes.sectionText}>
              <strong>{t('coldOutreachAlt')}</strong> {t('coldOutreachDescription')}
            </Typography>
            <Typography component="li" className={classes.sectionText}>
              <strong>{t('inMarketOutreachAlt')}</strong> {getLocalizedText('inMarketOutreachDescription', productGroup, t)}
            </Typography>
          </ul>
        </section>
        <section className={classes.section}>
          <Typography className={classes.sectionTitle}>{t('requiredContactListInfo')}</Typography>
          <Typography className={classes.sectionText}>{getLocalizedText('contactListDescription', productGroup, t)}</Typography>
        </section>
      </div>
    </>
  );
};

const useStyles = makeStyles()((theme) => ({
  titleContainer: {
    padding: '24px 64px',
  },
  title: {
    fontSize: theme.typography.pxToRem(25),
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },
  scrollContent: {
    padding: '0 64px 32px 64px',
    overflow: 'auto',
  },
  section: {
    marginTop: '32px',
    '&:first-of-type': {
      marginTop: '0px',
    },
  },
  sectionTitle: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 'bold',
    color: theme.palette.text.primary,
    marginBottom: '8px',
  },
  sectionText: {
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.text.secondary,
  },
  sectionList: {
    marginTop: '8px',
    marginBottom: '8px',
    paddingLeft: '32px',
    '& li': {
      marginBottom: '4px',
    },
  },
}));

export default SourcingContacts;
